export default __webpack_public_path__ + "static/media/about-fund-hand.68f16e59.png";